import axios from "axios";
import React, { useEffect, useState } from "react";
import { useAppDispatch } from "../../redux/hooks";
import { startLoading, stopLoading } from "../../redux/QuestionnaireSlice";
import { Link, useHistory } from "react-router-dom";
import { Box, Card, CardHeader, Typography } from "@mui/material";
import { selectFiles } from "../FileUploader/FileUploaderSlice";
import { useSelector } from "react-redux";
import { setErrMsg } from "../../redux/UserSlice";
import { set } from "date-fns";
import { MAIN_URL } from "../../redux/UserAPI";


export function LandingPage() {
  const dispatch = useAppDispatch();

  const history = useHistory();

  const files = useSelector(selectFiles)

  const [isDone, setIsDone] = useState(false);
  const currentUrl = window.location.href;
  const parseURLParams = (url: string) => {
    const queryStart = url.indexOf("?") + 1,
      queryEnd = url.indexOf("#") + 1 || url.length + 1,
      query = url.slice(queryStart, queryEnd - 1),
      pairs = query.replace(/\+/g, " ").split("&");
    let parms: any = {},
      i,
      n,
      v,
      nv;
  
    if (query === url || query === "") return;
  
    for (let i = 0; i < pairs.length; i++) {
      nv = pairs[i].split("=", 2);
      n = decodeURIComponent(nv[0]);
      v = decodeURIComponent(nv[1]);
  
      if (!parms.hasOwnProperty(n)) parms[n] = [];
      parms[n].push(nv.length === 2 ? v : null);
    }
    return parms;
  };
  const params = parseURLParams(currentUrl);
  const status = params.event ? params.event[0] : ''
  useEffect(() => {

    const sendDocument = async () => {
      const send = async () => {
        dispatch(startLoading());
        const envelopeId = localStorage.getItem("envelopeId");
        const imgName = localStorage.getItem("imgName");
        const accessToken = localStorage.getItem("accessToken");
        try {
          const response = await axios({
            method: "POST",
            url: `${MAIN_URL}/form/send_document`,
            data: {
              envelopeId,
              accessToken,
             imgName
            },
          });
   console.log(response)
   if(response.data.success){
    localStorage.setItem("uploaded", "true")
   }
        } catch (error) {
          console.log(error)
          dispatch(setErrMsg('File was not uploaded!'))
          dispatch(stopLoading());
          console.log(error);
          history.push("/");
        }
      };
      if(!localStorage.getItem("uploaded")){
        await send();
      }
    
    };
    if (status !== "decline" && status !== "reject" && status !== "session_timeout")
    {sendDocument()}
    dispatch(stopLoading())
  }, []);

  return (
    <Box sx={{ marginTop: "13em", marginBottom: 2, marginX: 'auto', width: '50%' }}>
      <Card variant="outlined">
        <CardHeader
          title={ status === "decline" ? 'Signing declined' : (status === "reject" ? 'Signing rejected' : (status === "session_timeout" ? 'Session timeout' : 'Signing completed!'))}
          subheader={ status === "decline" || status === 'reject' || status === "session_timeout" ? <Typography>To apply for the program you need to fill out the <Link to='/form'>application form</Link> again. </Typography> : "You may close the app."}
        />

      </Card>
    </Box>
  );
}
